import { combineReducers } from "redux";
import version from "./version";
import timesync from "./timesync";
import contents from "./contents";

const rootReducer = combineReducers({
  version,
  timesync,
  contents,
});
export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
